import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: "dtm-main-page-lib-caa-subpage",
    templateUrl: "./caa-subpage.component.html",
    styleUrls: ["../shared.scss", "./caa-subpage.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CaaSubpageComponent {}
